var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82816 8.48475L7.48502 2.8279C8.65659 1.65633 10.5561 1.65633 11.7277 2.8279C12.8992 3.99947 12.8992 5.89897 11.7277 7.07054L5.01014 13.7881C4.42436 14.3738 3.47461 14.3738 2.88882 13.7881C2.30304 13.2023 2.30304 12.2525 2.88882 11.6667L8.89923 5.65633C9.09449 5.46106 9.09449 5.14448 8.89923 4.94922C8.70397 4.75396 8.38739 4.75396 8.19212 4.94922L2.18172 10.9596C1.20541 11.9359 1.20541 13.5189 2.18172 14.4952C3.15803 15.4715 4.74094 15.4715 5.71725 14.4952L12.4348 7.77765C13.9969 6.21555 13.9969 3.68289 12.4348 2.12079C10.8727 0.558694 8.34001 0.558694 6.77791 2.12079L1.12106 7.77765C0.925794 7.97291 0.925794 8.28949 1.12106 8.48475C1.31632 8.68001 1.6329 8.68001 1.82816 8.48475Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.490fd8c4.svg";
export { ForwardRef as ReactComponent };